import { render, staticRenderFns } from "./brokerageSale.vue?vue&type=template&id=5799cb80&"
import script from "./brokerageSale.vue?vue&type=script&lang=js&"
export * from "./brokerageSale.vue?vue&type=script&lang=js&"
import style0 from "./brokerageSale.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports